import { render } from "./ResponsiveTable.vue?vue&type=template&id=65b0150a&scoped=true"
import script from "./ResponsiveTable.vue?vue&type=script&lang=js"
export * from "./ResponsiveTable.vue?vue&type=script&lang=js"

import "./ResponsiveTable.vue?vue&type=style&index=0&id=65b0150a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b0150a"]])

export default __exports__